




































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator'
import { APICarrier } from '../../models/api/carrier.model'

@Component
export default class CarrierPoliciesForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        carrierPolicyEnabled: true,
        typeId: {
            id: null
        }
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        carrierPolicyValue: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 255) || 'Field must be less than 255 characters'
        ],
        carrierPolicyDescription: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 255) || 'Field must be less than 255 characters'
        ]
    }

    formModel: { carriers: APICarrier[]; types: object[] } = {
        carriers: [],
        types: [
            {
                text: 'sms_delivery_time_range',
                value: 'sms_delivery_time_range'
            },
            {
                text: 'sms_daily_quota',
                value: 'sms_daily_quota'
            },
            {
                text: 'max_charging_daily_retries',
                value: 'max_charging_daily_retries'
            },
            {
                text: 'auto_unsub_uncharged_users',
                value: 'auto_unsub_uncharged_users'
            }
        ]
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await this.getCarriers()

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Carrier Policy'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Carrier Policy'
            this.data = {}
            this.loading = false
            break
        }
    }

    getCarriers () {
        return new Promise(resolve => {
            this.$store.dispatch('getCarriers')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map((p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getCarrierPoliciesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.CarrierPoliciesStore.carrierpolicyForm
                    this.formData.carrierId = this.formData.carrierId.carrierId
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editCarrierPolicies', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'CarrierPolicies'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createCarrierPolicies', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'CarrierPolicies'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
